import { WHY_INVICTO } from '../data/content';
import { Reveal, Eyebrow } from './Reveal';

export const WhyInvicto = () => (
  <section id="why" data-testid="why-section" className="bg-espresso">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
      <div className="mb-14 md:mb-20">
        <Eyebrow>Why Invicto</Eyebrow>
        <Reveal>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl font-light leading-tight text-cream sm:text-4xl lg:text-5xl">
            Built around <span className="italic text-gold">how it should feel</span> to build with us.
          </h2>
        </Reveal>
      </div>

      <div className="grid gap-px overflow-hidden border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_INVICTO.map((w, i) => (
          <Reveal key={w.id} delay={i * 0.08} className="h-full">
            <div className="flex h-full flex-col bg-[#211B15] p-7 transition-colors duration-500 hover:bg-[#2C251D] md:p-8">
              <span className="font-serif text-4xl font-light italic text-gold">{`0${i + 1}`}</span>
              <h3 className="mt-5 font-serif text-xl font-normal text-cream md:text-2xl">{w.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-sand/70">{w.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
